/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Faq_Q4Inputs */

const en_pc_online_faq_q4 = /** @type {(inputs: Pc_Online_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The app window stays blank. What can I do?`)
};

const zh_pc_online_faq_q4 = /** @type {(inputs: Pc_Online_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用窗口一直空白怎么办？`)
};

/**
* | output |
* | --- |
* | "The app window stays blank. What can I do?" |
*
* @param {Pc_Online_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_faq_q4 = /** @type {((inputs?: Pc_Online_Faq_Q4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Faq_Q4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_faq_q4(inputs)
	return zh_pc_online_faq_q4(inputs)
});
export { pc_online_faq_q4 as "pc.online.faq.q4" }